import { getItemByRef } from 'chameleon/packages/blue-book-player/utils';
import { SELECTORS } from 'chameleon/packages/blue-book-player/constants/selectors';

const OPTION_LABELS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const setAnswerChoiceLabel = (playerEl, currentQuestion) => {
  const questionContainer = getItemByRef(
    playerEl,
    currentQuestion.learnosityItemReference,
  ).querySelectorAll(SELECTORS.OPTION_ANSWER);

  questionContainer.forEach((option, index) => {
    const label = document.createElement('span');
    label.textContent = `Option ${OPTION_LABELS[index]},`;
    label.classList.add('sr-only');
    const labelId = option
      ?.querySelector(SELECTORS.OPTION_ANSWER_INPUT)
      ?.getAttribute('aria-labelledby');
    document.getElementById(labelId)?.prepend(label);
  });
};

export const removeAriaHiddenFromResponse = (playerEl, currentQuestion) => {
  const questionContainer = getItemByRef(
    playerEl,
    currentQuestion.learnosityItemReference,
  ).querySelectorAll(SELECTORS.OPTION_ANSWER);

  questionContainer.forEach((response) => {
    const responseLabel = response.querySelector(SELECTORS.OPTION_ANSWER_LABEL);
    responseLabel.removeAttribute('aria-hidden');
    responseLabel.querySelectorAll('[aria-hidden]').forEach((el) => {
      el.removeAttribute('aria-hidden');
    });
  });
};
